module.exports = __webpack_public_path__ + "static/media/K-empty-open.e51fa5b6.svg";